import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appBoleanColor]'
})
export class StatusBoleanDirective implements OnChanges {

  @Input() appBoleanColor: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(): void {
    this.updateColor();
  }

  private updateColor(): void {
    if (this.appBoleanColor && this.appBoleanColor === true) {
      this.renderer.setStyle(this.el.nativeElement, 'color', 'green');
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'color', 'red');
    }
  }
}